export const APP_NAME = 'Fleet Assistant';

export const ONBOARDING_THREAD_ID = 'onboarding-thread';